var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"item--color__price m-2"},[(_vm.isLoading)?_c('b-skeleton',{attrs:{"width":"100%"}}):[(_vm.pricing.printable)?[_vm._v(" "+_vm._s(_vm._f("currency")(_vm._f("toCents")(_vm.singlePrice)))+"* ")]:[_vm._v(_vm._s(_vm._f("currency")(null)))]]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }